"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const components_action_Button_Button = require("../../action/Button/Button.js");
const components_overlay_Modal_components_ModalContainer = require("../Modal/components/ModalContainer.js");
const components_overlay_Modal_components_ModalFooter = require("../Modal/components/ModalFooter.js");
const components_overlay_Modal_components_ModalHeader = require("../Modal/components/ModalHeader.js");
const components_overlay_Modal_Modal = require("../Modal/Modal.js");
const dialog = "_dialog_hr5ye_3";
const dialogHeader = "_dialogHeader_hr5ye_28";
const dialogBody = "_dialogBody_hr5ye_43";
const dialogFooter = "_dialogFooter_hr5ye_54";
const dialogButton = "_dialogButton_hr5ye_73";
const dialogEntering = "_dialogEntering_hr5ye_77";
const dialogExiting = "_dialogExiting_hr5ye_85";
const styles = {
  dialog,
  dialogHeader,
  dialogBody,
  dialogFooter,
  dialogButton,
  dialogEntering,
  dialogExiting
};
const Dialog = ({
  cancelButton,
  confirmButton,
  children,
  dialogTitle,
  isOpen,
  isAlertDialog,
  isLoading = false,
  isLoadingDescription,
  renderIn,
  restoreFocus = true,
  onCancel,
  onConfirm,
  requiresExplicitChoice,
  closeButtonDescription
}) => {
  return /* @__PURE__ */ jsxRuntime.jsx(
    components_overlay_Modal_Modal.Modal,
    {
      restoreFocus,
      isDismissable: !requiresExplicitChoice,
      onClose: onCancel,
      renderIn,
      isOpen,
      children: /* @__PURE__ */ jsxRuntime.jsxs(
        components_overlay_Modal_components_ModalContainer.ModalContainer,
        {
          role: isAlertDialog ? "alertdialog" : "dialog",
          className: styles.dialog,
          component: "div",
          "aria-modal": true,
          "aria-label": dialogTitle,
          transitionStyles: {
            entering: styles.dialogEntering,
            exiting: styles.dialogExiting
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(
              components_overlay_Modal_components_ModalHeader.ModalHeader,
              {
                className: styles.dialogHeader,
                closeButtonDescription,
                children: dialogTitle
              }
            ),
            /* @__PURE__ */ jsxRuntime.jsx("div", { className: styles.dialogBody, children: typeof children === "string" ? /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.Text, { children }) : /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children }) }),
            /* @__PURE__ */ jsxRuntime.jsxs(components_overlay_Modal_components_ModalFooter.ModalFooter, { className: styles.dialogFooter, children: [
              /* @__PURE__ */ jsxRuntime.jsx(
                components_action_Button_Button.Button,
                {
                  className: styles.dialogButton,
                  variant: "primary",
                  size: "medium",
                  component: "button",
                  onPress: onConfirm,
                  isLoading,
                  isLoadingDescription,
                  children: confirmButton
                }
              ),
              /* @__PURE__ */ jsxRuntime.jsx(
                components_action_Button_Button.Button,
                {
                  className: styles.dialogButton,
                  variant: "outline",
                  size: "medium",
                  component: "button",
                  onPress: onCancel,
                  children: cancelButton
                }
              )
            ] })
          ]
        }
      )
    }
  );
};
exports.Dialog = Dialog;
